import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "logo-wrap flex justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "form-title"
}
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = { class: "input-label" }
const _hoisted_8 = { class: "input-warn flex" }
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-box" }
const _hoisted_11 = { class: "input-label" }
const _hoisted_12 = { class: "suffix-wrap" }
const _hoisted_13 = { class: "extra-wrap" }
const _hoisted_14 = { class: "terms-wrap" }
const _hoisted_15 = { class: "highlight" }

import { ref, reactive, computed, inject, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import md5 from 'js-md5';
import { useHelpTool } from '@/hooks';
import { useUserStore } from '@/store'
import { queryWelcomeData, customRegister } from "@/api"; 


export default {
  __name: 'register',
  setup(__props) {

const UserHelper = inject('userHelper');

const MyToast = inject('myToast')

const route = useRoute();
const router = useRouter()
const { t } = useI18n()
const { imageByTheme } = useHelpTool()

const userStore = useUserStore();
 
const form = reactive({
  username: '',
  password: '',
  code: '',
})

const showPassword = ref(false)
const welcomeData = ref({});

const registerDisabled = computed(() => {
  return form.username.length < 6 || form.password.length < 6;
})


onMounted(() => {
  form.code = decodeURIComponent(decodeURIComponent(route.query?.code));
  queryWelcomeData().then(res => {
    welcomeData.value = res.data || {};
  })
})

const doRegister = () => {
  customRegister({
    username: form.username,
    password: md5(form.password),
    code: form.code,
  }).then(res => {
    MyToast({ type: 'success', message: t('notify.registerSuccess') });
    let userData = res.data || {}
    userStore.setUserInfo(userData);
    UserHelper.init();
    router.replace({ name: 'game' });
  });
}

const inputBlur = (e) => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

return (_ctx, _cache) => {
  const _component_HeaderBar = _resolveComponent("HeaderBar")
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBar),
    _createVNode(_component_NavBar, {
      title: _ctx.$t('common.register')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          class: "logo-img",
          src: _unref(imageByTheme)('logo.png')
        }, null, 8, ["src"])
      ]),
      (welcomeData.value.registerReward)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('user.signUpBonus').format({ amount: welcomeData.value.registerReward })), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_van_form, {
        class: "input-form",
        onSubmit: doRegister
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('label.username')) + ":", 1),
              _createVNode(_component_van_field, {
                modelValue: form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.username) = $event)),
                name: "username",
                class: "input-field",
                onInput: _cache[1] || (_cache[1] = $event => (form.username = _ctx.$filter.numberLetterOnly($event.target.value) )),
                onBlur: _cache[2] || (_cache[2] = $event => (form.username = _ctx.$filter.numberLetterOnly($event.target.value))),
                maxlength: "13",
                clearable: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_icon, {
              class: "warn-icon",
              name: "warning"
            }),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('placeholder.username')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.pwd')) + ":", 1),
              _createVNode(_component_van_field, {
                modelValue: form.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((form.password) = $event)),
                name: "password",
                class: "input-field",
                type: !showPassword.value ? 'password' : 'text',
                onBlur: inputBlur,
                maxlength: "12",
                clearable: ""
              }, null, 8, ["modelValue", "type"]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createVNode(_component_van_icon, {
                  class: "eye-icon",
                  name: !showPassword.value ? 'eye' : 'closed-eye',
                  onClick: _cache[4] || (_cache[4] = $event => (showPassword.value=!showPassword.value))
                }, null, 8, ["name"]), [
                  [_directive_audio]
                ])
              ])
            ])
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            "native-type": "submit",
            class: "submit-btn",
            block: "",
            disabled: registerDisabled.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.register').toUpperCase()), 1)
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_audio]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_13, [
        _createTextVNode(_toDisplayString(_ctx.$t('user.haveAccount')) + " ", 1),
        _withDirectives((_openBlock(), _createElementBlock("span", {
          class: "highlight",
          onClick: _cache[5] || (_cache[5] = $event => (_unref(router).push({ name: 'login' })))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('common.login')), 1)
        ])), [
          [_directive_audio]
        ])
      ]),
      _createVNode(_component_van_image, {
        class: "banner-img",
        src: require('@/assets/img/user/banner.png')
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode(_toDisplayString(_ctx.$t('user.terms.content1')) + " ", 1),
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('user.terms.content2')), 1)
      ])
    ])
  ]))
}
}

}